<div class="custom-ag-header" [ngClass]="{'sort-enabled': params.enableSorting}">
  <!-- Single button for the whole header: label + sort indicator in one control.
       Previously there were 3 buttons per header (label + ascending + descending),
       causing Dragon to assign 3 numbers to the same visual control.
       The sort icon is decorative (aria-hidden) — sort state is communicated via
       aria-sort on the AG Grid header cell (set in updateAriaSort()).
       The text is wrapped in .header-text so overflow:hidden/ellipsis only clip
       the text, not the sort icon (which was hidden on narrow columns before). -->
    <!-- Only sortable columns render an interactive button. Non-sortable labels
      remain plain spans: hidden headers such as Select are skipped, while a
      visible named header such as Actions can make its columnheader wrapper a
      static Tab stop without falsely presenting the label as a button. -->
  <button *ngIf="params.enableSorting; else nonSortableLabel"
      type="button" class="customHeaderLabel" placement="top" [pTooltip]="params.displayName" tooltipPosition="right"
      [tooltipEvent]="params.showTooltipOnFocus === false ? 'hover' : 'both'"
       [attr.aria-label]="params.displayName | translate"
       (click)="toggleSortOrder($event)" (touchstart)="toggleSortOrder($event)">
    <span class="header-text">{{ params.displayName | translate}}</span>
    <span class="sort-icon-wrapper" aria-hidden="true">
      <i [ngClass]="getSortOrderStatus('asc')" class="customSortDownLabel">
        <svg class="icon" aria-hidden="true"><use xlink:href="#icon-sort-ascending" /></svg>
      </i>
      <i [ngClass]="getSortOrderStatus('desc')" class="customSortUpLabel">
        <svg class="icon" aria-hidden="true"><use xlink:href="#icon-sort-descending" /></svg>
      </i>
    </span>
  </button>
  <!-- Opt-in only (params.showHeaderTooltip): most non-sortable headers
       (Select, Actions) stay tooltip-free as before - the pTooltip directive
       is only present in the DOM (and so only bridges focus/blur, see
       ngAfterViewInit) when a grid explicitly asks for the same PrimeNG
       tooltip its sortable headers use, e.g. Historical Data's date columns
       via headerComponentParams.showHeaderTooltip. -->
  <ng-template #nonSortableLabel>
    <span class="customHeaderLabel" *ngIf="!params.showHeaderTooltip; else nonSortableLabelWithTooltip">
      <span class="header-text">{{ params.displayName | translate}}</span>
    </span>
  </ng-template>
  <ng-template #nonSortableLabelWithTooltip>
    <!-- The tooltip is bound to .header-text (sized to the text itself), not
         the outer full-width .customHeaderLabel span: a narrow, left-aligned
         label (e.g. a short date) leaves a lot of empty column space to its
         right, and PrimeNG's "right" position anchors off the ELEMENT it is
         bound to. Binding the outer span placed the tooltip off in that empty
         space instead of next to the visible text. -->
    <span class="customHeaderLabel">
      <span class="header-text"
          [pTooltip]="params.displayName" tooltipPosition="right"
          [tooltipEvent]="params.showTooltipOnFocus === false ? 'hover' : 'both'">{{ params.displayName | translate}}</span>
    </span>
  </ng-template>
</div>
<svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
  <symbol id="icon-sort-ascending" viewBox="0 0 20 20">
    <path d="M6.1 13.1c0.3 0 0.5-0.1 0.7-0.3l3.2-3.2 3.2 3.2c0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3c0.4-0.4 0.4-1 0-1.4l-3.9-3.9c-0.1-0.1-0.2-0.2-0.3-0.2-0.2-0.1-0.5-0.1-0.8 0-0.1 0-0.2 0-0.3 0.1l-3.9 3.9c-0.4 0.4-0.4 1 0 1.4 0.2 0.3 0.4 0.4 0.7 0.4z"></path>
  </symbol>
  <symbol id="icon-sort-descending" viewBox="0 0 20 20">
    <path d="M13.2 7.2l-3.2 3.2-3.2-3.2c-0.4-0.4-1-0.4-1.4 0s-0.4 1 0 1.4l3.9 3.9c0.1 0.1 0.2 0.2 0.3 0.2 0.1 0.1 0.3 0.1 0.4 0.1s0.3 0 0.4-0.1c0.1-0.1 0.2-0.1 0.3-0.2l3.9-3.9c0.4-0.4 0.4-1 0-1.4s-1-0.4-1.4 0z"></path>
  </symbol>
  <symbol id="icon-sort">
    <path d="M6.1 8.1c0.3 0 0.5-0.1 0.7-0.3l3.2-3.2 3.2 3.2c0.2 0.2 0.5 0.3 0.7 0.3s0.5-0.1 0.7-0.3c0.4-0.4 0.4-1 0-1.4l-3.9-3.9c-0.1-0.1-0.2-0.2-0.3-0.2-0.2-0.1-0.5-0.1-0.8 0-0.1 0-0.2 0-0.3 0.1l-3.9 4c-0.4 0.4-0.4 1 0 1.4 0.2 0.2 0.4 0.3 0.7 0.3z"></path>
    <path d="M13.2 12.2l-3.2 3.2-3.2-3.2c-0.4-0.4-1-0.4-1.4 0s-0.4 1 0 1.4l3.9 3.9c0.1 0.1 0.2 0.2 0.3 0.2 0.1 0.1 0.3 0.1 0.4 0.1s0.3 0 0.4-0.1c0.1-0.1 0.2-0.1 0.3-0.2l3.9-3.9c0.4-0.4 0.4-1 0-1.4s-1-0.4-1.4 0z"></path>
  </symbol>
</svg>
